module.exports = __webpack_public_path__ + "static/media/8 - Domenique Dumont - Sans cesse, mon chéri.cf30166b.mp3";